'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
require('./Brand.css');
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Brand = function Brand(_ref) {
  var logo = _ref.logo,
    brandName = _ref.brandName,
    productName = _ref.productName,
    href = _ref.href,
    onClick = _ref.onClick,
    size = _ref.size;
  var brandClassNames = (0, _classnames2.default)('c-brand', {
    'c-brand--large': size === 'large'
  });
  return _react2.default.createElement('a', {
    className: brandClassNames,
    href: href,
    onClick: onClick
  }, logo && _react2.default.createElement('img', {
    src: logo
  }), _react2.default.createElement('div', {
    className: 'c-brand__text'
  }, brandName + ' ', productName && _react2.default.createElement('span', null, productName)));
};
Brand.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Source of the brand logo*/
  logo: _propTypes2.default.string,
  /** The brand name*/
  brandName: _propTypes2.default.string,
  /** The product name*/
  productName: _propTypes2.default.string,
  /** The link */
  href: _propTypes2.default.string,
  /** onClick event function*/
  onClick: _propTypes2.default.func,
  /** size of the brand labeling */
  size: _propTypes2.default.oneOf(['default', 'large'])
} : {};
exports.default = Brand;